module.exports = __webpack_public_path__ + "assets/img/wddkll.458ca76e.jpg";